export function isRuntimeConnectionError(error) {
  const detail = String(error?.message || "").trim();
  return /connect ENOENT.*LensCore\.Runtime\.Bridge|runtime bridge (?:closed|timed out)|named[- ]pipe bridge/i.test(detail);
}

export function userFacingError(error) {
  const detail = String(error?.message || "").trim();
  if (!detail) return null;
  const lensErrors = {
    FETCH_FAILED: ["Lens download failed", "Check the connection or lens URL and try again."],
    INVALID_LENS_RESPONSE: ["That was not a lens file", "The server returned a web page instead of lens data. You may need to sign in again."],
    INVALID_LENS_SOURCE: ["Lens source is invalid", "Choose a valid lens file or URL."],
    MODIFICATION_FAILED: ["Lens preparation failed", "The original lens was preserved and was not loaded."],
    ENGINE_NOT_READY: ["LensCore is still starting", "Wait a moment and try loading the lens again."],
    ENGINE_LOAD_FAILED: ["Lens could not be loaded", "LensCore rejected this lens package."],
    RUNTIME_EXCEPTION: ["Lens stopped unexpectedly", "A script or runtime operation failed after the lens loaded."],
    REMOTE_ASSET_FAILED: ["A lens asset is unavailable", "The lens loaded, but part of the effect may be missing."],
    FIRST_FRAME_TIMEOUT: ["Lens did not start rendering", "LensCore accepted the lens but did not produce a frame in time."],
  };
  if (error?.code && lensErrors[error.code]) {
    const [title, message] = lensErrors[error.code];
    return { title, message, detail, code: error.code, stage: error.stage || null };
  }
  if (isRuntimeConnectionError(error)) {
    return {
      title: "LensCore is reconnecting",
      message: "The rendering service stopped unexpectedly. This usually takes only a moment.",
      detail,
    };
  }
  if (/CefInitialize returned false/i.test(detail)) {
    return {
      title: "Virtual Camera could not start",
      message: "The native renderer failed to initialize, so LensCore released the physical camera.",
      detail,
    };
  }
  if (/native runtime is not connected|runtime.*not.*available/i.test(detail)) {
    return {
      title: "Rendering service is unavailable",
      message: "Preview can continue, but Virtual Camera output is temporarily unavailable.",
      detail,
    };
  }
  if (/virtual camera helper was not found|Windows error 0x2/i.test(detail)) {
    return {
      title: "Virtual Camera component is missing",
      message: "Repair or reinstall LensCore to restore Virtual Camera output.",
      detail,
    };
  }
  if (/Cloudflare Access rejected the native renderer session|cloud renderer assets were blocked by authentication/i.test(detail)) {
    return {
      title: "Please sign in again",
      message: "LensCore could not open the protected renderer with your current session.",
      detail,
    };
  }
  return { title: "LensCore needs attention", message: "Something went wrong. Open Diagnostics for details.", detail };
}
